<template>
  <div>
    <SpeechAndLanguage />
  </div>
</template>

<script>
import SpeechAndLanguage from './SpeechAndLanguage';
export default {
  components: {
    SpeechAndLanguage,
  },
};
</script>

<style lang="scss" scoped></style>
